import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { http, formatApiError } from "../lib/api";
import { Logo } from "../components/site/Logo";
import { AdminDashboard } from "../components/admin/AdminDashboard";

const Login = ({ onDone }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      onDone(data);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-5">
      <form onSubmit={submit} className="w-full max-w-sm rounded-[28px] border border-white/10 bg-[#161D17] p-8" data-testid="admin-login-form">
        <Link to="/" className="flex items-center gap-2"><Logo /><span className="font-display text-xl font-extrabold">Go Box</span></Link>
        <h1 className="mt-8 font-display text-3xl font-extrabold">Orders admin</h1>
        <div className="mt-6 grid gap-4">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required className="field" data-testid="admin-email-input" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required className="field" data-testid="admin-password-input" />
          {error && <p className="text-sm text-[#F2A08C]" data-testid="admin-login-error">{error}</p>}
          <button disabled={busy} className="btn-gold justify-center py-3.5" data-testid="admin-login-button">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Sign in"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default function Admin() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    http.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const logout = async () => {
    await http.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  if (user === null) return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[var(--gold)]" /></div>;
  if (!user) return <Login onDone={setUser} />;
  return <AdminDashboard user={user} onLogout={logout} />;
}
